import React from 'react';
import { LifeBuoyIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CtaSection() {
  return <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-152">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-153">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-154">
          {/* Main CTA */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200" data-id="element-155">
            <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2] mb-4" data-id="element-156">
              See exactly what your family hasn't done yet — and what to do
              first.
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-8" data-id="element-157">
              Our free checkup takes 3 minutes. No email, no credit card, no
              jargon. Just a clear picture of where your family stands and what
              to fix first.
            </p>
            <Link to="/onboarding" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-medium text-sm inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-158">
              Take the Free Checkup
            </Link>
          </div>

          {/* Crisis CTA */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200" data-id="element-159">
            <div className="flex items-center mb-4" data-id="element-160">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-161">
                <LifeBuoyIcon className="w-6 h-6 text-[#631bb7]" data-id="element-162" />
              </div>
              <h3 className="text-xl md:text-[1.75rem] font-semibold text-[#111111] leading-[1.3]" data-id="element-163">
                Has Someone You Love Been Victimized?
              </h3>
            </div>
            <p className="text-base text-gray-600 leading-relaxed mb-6" data-id="element-164">
              If you or a loved one has been scammed or hacked, our free Crisis
              Response Guide walks you through exactly what to do — step by step
              — including who to contact first and how to limit the damage.
            </p>
            <Link to="/crisis-help" className="bg-[#631bb7] text-white px-6 py-3 rounded-lg font-medium text-sm inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-165">
              See the Crisis Response Guide →
            </Link>
          </div>
        </div>
      </div>
    </section>;
}